import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, VStack } from '@chakra-ui/react'
import { REGISTER_SCHEMA_STEP_ONE, RegisterStepOneType, useRegisterStep } from 'context/Register'
import { Formik } from 'formik'

import { InputControl, SubmitButton } from 'components/InputCustom'
import { customToast } from 'components/ToastCustom'


export const StepOne = () => {
  const navigate = useNavigate()

  const {
    clearError,
    stepOneDispatch,
    registerStepState: {
      error,
      loading,
      state: {
        registerMock: { email, phone, confirmEmail },
      },
    },
  } = useRegisterStep()

  const initialValues: RegisterStepOneType = {
    email: email ? email : '',
    phone: phone ? phone : '',
    confirmEmail: confirmEmail ? confirmEmail : '',
  }

  useEffect(() => {
    if (error)
      customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={stepOneDispatch}
      validationSchema={REGISTER_SCHEMA_STEP_ONE}>
      <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
        <InputControl
          inputProps={{ placeholder: 'Ingresar correo electrónico' }}
          name='email'
          label='Correo electrónico'
          isDisabled={loading}
        />
        <InputControl
          inputProps={{ placeholder: 'Confirmar correo electrónico' }}
          name='confirmEmail'
          label='Correo electrónico'
          isDisabled={loading}
        />
        <InputControl
          inputType='phone'
          inputProps={{ placeholder: '87654321', maxLength: 8 }}
          name='phone'
          label='Teléfono'
          isDisabled={loading}
        />
        <SubmitButton
          w={'full'}
          isLoading={loading}
          loadingText='Validando...'>
          Siguiente
        </SubmitButton>
        <Button w={'full'} variant={'secondary'} onClick={() => navigate('/')}>Volver</Button>
      </VStack>
    </Formik>
  )
}
